<script lang="ts">
    import { api } from '../../../stores/api';
    import { openModal } from 'svelte-modals';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import { getFilterQuery } from '../../utilities/getFilterQuery';
    import ModalError from '../../shared/Modals/ModalError.svelte';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import IconClose from '../../shared/Icons/IconClose.svelte';
    import { jobs } from '../../../stores/store';
    import { LocationApi } from './LocationApi';
    import { filter } from '../../../stores/filter';
    import { Umami } from '../../utilities/Umami';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    let selectedCount: number = 0;

    function removeSelected() {
        openModal(ModalRemoveSomething, {
            text: $_('Are you sure you want to remove selected jobs?'),
            name: `${selectedCount} ` + $_('selected'),
            onClick: () => {
                let request: Promise<{ removed: number }>;
                if ($jobs.selectMode === 'selected') {
                    request = LocationApi.removeWithQuery(get(api), {
                        $and: [
                            getFilterQuery($filter.jobsToBeCompleted),
                            { id: { $in: $jobs.selectedOrUnselected } },
                        ],
                    });
                } else {
                    request = LocationApi.removeWithQuery(get(api), {
                        $and: [
                            getFilterQuery($filter.jobsToBeCompleted),
                            { id: { $nin: $jobs.selectedOrUnselected } },
                        ],
                    });
                }
                request
                    .then(response => {
                        console.log('remove jobs', response);
                        Umami.event('jobs_deleted', { count: response.removed });
                    })
                    .catch(error => {
                        console.warn('remove jobs', error);
                        Umami.error('jobs_deleted', error, { count: selectedCount });
                        openModal(ModalError, {
                            message: $_('some_jobs_could_not_be_modified'),
                        });
                    })
                    .finally(() => {
                        $jobs.selectedOrUnselected = [];
                        $jobs.selectMode = 'selected';
                        $jobs.forceRecount = true;
                        $jobs.forceReload = true;
                    });
            },
        });
    }

    $: {
        if ($jobs.selectMode === 'selected') {
            selectedCount = $jobs.selectedOrUnselected.length;
        } else {
            selectedCount = $jobs.countFiltered.count - $jobs.selectedOrUnselected.length;
        }
    }
</script>

<div class="lm--action_bar" style="display: flex;">
    <div>
        <span class="text-span-10">{$_('Selected items')}</span>:
        <strong>{selectedCount}</strong>
    </div>
    <div class="lm--action_bar_loptions">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div title={$canWrite ? '' : $_(writeDisabledTooltip)}>
            <div
                class="lm--icon_with_text"
                class:write-blocked={!$canWrite}
                on:click={removeSelected}
            >
                <IconRemove scale={0.7} />
                <div>{$_('remove_jobs')}</div>
            </div>
        </div>
        <IconClose
            scale={0.7}
            on:click={() => {
                $jobs.selectedOrUnselected = [];
                $jobs.selectMode = 'selected';
            }}
        />
    </div>
</div>

<style>
    .lm--action_bar {
        font-size: 14px;
        z-index: 1;
        height: 68px;
        color: #fff;
        background-color: #397be5;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        display: none;
        position: absolute;
        top: -13px;
        bottom: auto;
        left: 0;
        right: 0;
    }
    .lm--action_bar_loptions {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        /*filter: invert();*/
        color: #000;
        align-items: center;
        font-weight: 500;
        line-height: 14px;
        display: flex;
    }
    .lm--icon_with_text {
        grid-column-gap: 5px;
        grid-row-gap: 5px;
        cursor: pointer;
        align-items: center;
        display: flex;
        filter: invert();
    }
    /* przy braku can_write akcja nie lapie klikniec, a tooltip siedzi na obudowie */
    .lm--icon_with_text.write-blocked {
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
